import { DiscountKind } from '@avantstay/arriere-clients/dist/arriereBackoffice'

interface QuotePriceInCentsProps {
  // input can be in dollar or percentage based on discountKind
  discountInput: number
  discountKind?: DiscountKind
  applicableTotalInCents: number
  totalPriceInCents: number
}

export const calculateTotalWithDiscountInCents = ({
  discountInput,
  discountKind,
  applicableTotalInCents,
  totalPriceInCents,
}: QuotePriceInCentsProps) => {
  const discountInCents = discountInput * 100
  const discountPercentage = discountInput / 100

  return discountKind === DiscountKind.absolute
    ? totalPriceInCents - discountInCents
    : totalPriceInCents - applicableTotalInCents * discountPercentage
}

export const getDiscountInCents = (applicableTotalInCents: number, discountPercentage: number) =>
  (applicableTotalInCents / 100) * discountPercentage

export const getDiscountInPercentage = (discountInCents: number, applicableTotalInCents: number) =>
  (discountInCents * 100) / applicableTotalInCents
